import React, { useState } from 'react';
import styles from './index.module.scss';
import RenderInventoryItemAddress from './inventoryItemAddress';
import InventoryItemBasicDetails from './inventoryItemBasicDetails';
import InventoryItemQuantity from './InventoryItemQuantity';

const InventoryItem = (props) => {
  const { inventoryItem } = props;
  const {
    inventoryAddress = {},
  } = inventoryItem;

  const [isChecked, setIsChecked] = useState(false);
  const [inventoryAddressState, setInventoryItemState] = useState(inventoryAddress);
  const [showAddressEdit, setShowAddressEdit] = useState(false);
  return (
    <div
      style={{
        backgroundColor: isChecked ? 'rgba(5, 225, 119, 0.5)' : 'white',
      }}
      className={`${styles['item-container']} col inventory-item`}
    >

      <InventoryItemBasicDetails
        inventoryItem={inventoryItem}
        setShowAddressEdit={setShowAddressEdit}
      />
      {showAddressEdit ?
        <RenderInventoryItemAddress
          originalInventoryAddress={inventoryAddress}
          inventoryAddressState={inventoryAddressState}
          setInventoryItemState={setInventoryItemState}
          setShowAddressEdit={setShowAddressEdit}
        /> :
        <InventoryItemQuantity
          setIsChecked={setIsChecked}
          inventoryItem={inventoryItem}
          inventoryAddressState={inventoryAddressState}
          isChecked={isChecked}
        />}
    </div>
  );
};

export default InventoryItem;
